import ListView, { ListViewItem } from '@ingka/list-view';
import { selectCurrencyCode } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';
import { Heading } from '@repo/ui/typography';

import { useSalesPersonDiscounts } from '@/hooks/asset-price-discounts.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { formatPrice } from '@/utils/translation.utils';

import { PriceSummaryOverviewContentsList } from './price-summary-overview-contents-list.component';
import { PriceSummaryOverviewTotalsList } from './price-summary-overview-totals-list.component';

import styles from '../../styles.module.scss';

interface Props {
    onDiscountsClick: () => void;
}

export const PriceSummaryOverview = ({ onDiscountsClick }: Props) => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const currencyCode = selectCurrencyCode(data);
    const { discountListItems, discountListTotal } = useSalesPersonDiscounts();

    return (
        <>
            <div className={styles.asset_price_summary_top_list}>
                <Heading headingSize="xs" className={styles.asset_price_summary_top_list_header ?? ''}>
                    {translate('asset_price_summary_listing_header')}
                </Heading>
                <PriceSummaryOverviewContentsList />

                {discountListItems.length > 0 && (
                    <>
                        <hr className={styles.divider_top} />
                        <ListView id="discounts-link" size="medium" showDivider={false}>
                            <ListViewItem
                                control="navigational"
                                controlIcon="chevronRight"
                                description={translate('asset_price_summary_discounts_amount', {
                                    amountOfDiscounts: `${discountListItems.length}`,
                                })}
                                emphasised
                                onClick={onDiscountsClick}
                                quantityLabel={`- ${formatPrice(discountListTotal, currencyCode, {
                                    forceFixed: false,
                                })}`}
                                title={<strong>{translate('asset_price_summary_coupons_and_discounts')}</strong>}
                            />
                        </ListView>
                        <hr className={styles.divider} />
                    </>
                )}
            </div>

            <div className={styles.asset_price_summary_footer_list}>
                <hr className={styles.divider} />
                <PriceSummaryOverviewTotalsList />
            </div>
        </>
    );
};
